// 首页
export const URI_APPTASK_LIST = '/s1/apptask.list'
// 首页任务轮询
export const URI_APPTASK_START = '/s1/apptask.start'
// 任务详情
export const URI_APPTASK_DETAIL = '/s1/apptask.detail'
// 放弃任务
export const URI_APPTASK_GIVEUP = '/s1/apptask.giveup'
// 完成任务
export const URI_APPTASK_CHECK_STATUS = '/s1/apptask.check_status'
// 用户证书
export const URI_START = '/s1/start'
